(function () {
  'use strict';
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initHorizon() {
    var suns = document.querySelectorAll('.iris-sun');
    if (!suns.length) return;
    function update() {
      var doc = document.documentElement;
      var scrollTop = window.scrollY || doc.scrollTop;
      var max = (doc.scrollHeight - window.innerHeight) || 1;
      var progress = Math.min(Math.max(scrollTop / max, 0), 1);
      var pos = 6 + progress * 88;
      suns.forEach(function (sun) { sun.style.setProperty('--sun-pos', pos + '%'); });
    }
    if (prefersReduced) { suns.forEach(function (sun) { sun.style.setProperty('--sun-pos', '50%'); }); return; }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(function () { update(); ticking = false; }); ticking = true; }
    }, { passive: true });
    update();
  }
  function initReveal() {
    var items = document.querySelectorAll('.iris-reveal');
    if (!items.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { entry.target.classList.toggle('is-visible', entry.isIntersecting); });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    items.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 60 + 'ms'; observer.observe(el); });
  }
  function initCounters() {
    var items = document.querySelectorAll('[data-iris-count]');
    if (!items.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.textContent = el.getAttribute('data-iris-count'); }); return; }
    function animateCount(el) {
      var target = el.getAttribute('data-iris-count');
      var cleaned = target.replace(/,/g, '');
      var numMatch = cleaned.match(/[\d.]+/);
      if (!numMatch) { el.textContent = target; return; }
      var num = parseFloat(numMatch[0]);
      var isDecimal = numMatch[0].indexOf('.') > -1;
      var prefix = cleaned.slice(0, numMatch.index);
      var suffix = cleaned.slice(numMatch.index + numMatch[0].length);
      var duration = 1100;
      var start = null;
      function formatNumber(n) { if (isDecimal) return n.toFixed(1); return Math.round(n).toLocaleString('en-US'); }
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + formatNumber(num * eased) + suffix;
        if (p < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { animateCount(entry.target); } });
    }, { threshold: 0.6 });
    items.forEach(function (el) { observer.observe(el); });
  }
  function initParallax() {
    if (prefersReduced) return;
    var wave = document.querySelector('.iris-hero__wave');
    if (!wave) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(function () { var offset = Math.min(window.scrollY * 0.15, 40); wave.style.transform = 'translateY(' + offset + 'px)'; ticking = false; }); ticking = true; }
    }, { passive: true });
  }
  function initHeaderShrink() {
    var header = document.getElementById('SiteHeader');
    if (!header) return;
    function update() { header.classList.toggle('iris-header--shrink', window.scrollY > 40); }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }
  function initCardHoverSwap() {
    document.querySelectorAll('.iris-card[data-hover-src]').forEach(function (card) {
      var img = card.querySelector('.iris-card__media img');
      if (!img) return;
      var original = img.getAttribute('src');
      var hover = card.getAttribute('data-hover-src');
      if (!hover) return;
      card.addEventListener('mouseenter', function () { img.setAttribute('src', hover); });
      card.addEventListener('mouseleave', function () { img.setAttribute('src', original); });
    });
  }
  function initStickyAtc() {
    var bar = document.querySelector('[data-iris-sticky-atc]');
    var trigger = document.querySelector('[data-iris-atc-trigger]');
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { bar.classList.toggle('is-visible', !entry.isIntersecting); });
    }, { threshold: 0 });
    observer.observe(trigger);
  }
  function initFaq() {
    var items = document.querySelectorAll('.iris-faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) { items.forEach(function (other) { if (other !== item) other.open = false; }); }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    initHorizon(); initReveal(); initCounters(); initParallax(); initHeaderShrink(); initCardHoverSwap(); initStickyAtc(); initFaq();
  });
})();
